import React, { Component } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import logo from "../../assets/images/logo.png";


class PasswordMessage extends Component<any> {
  render() {
    const { show } = this.props;
    return (
      <Modal
        centered
        show={show}
        className={'profile-modal'}
        onHide={this.props.handleClose}
      >
        {/* @ts-ignore */}

        <Modal.Header className="align-items-center justify-content-center">
         

          <h3 className="mb-0 title"><Image src={logo} className="logo-height" style={{paddingBottom:"10px"}}/><br></br>Welcome to Lokem!</h3>
        </Modal.Header>
        <Modal.Body>
          <p className="text-left" style={{fontWeight:"500"}}>
          New password must contain:</p>
          <p className="text-left" style={{marginLeft:"-14px", fontWeight:"500"}}>
          <ul><li>At least 8 characters</li>
          <li>At least 1 lowercase character</li>
          <li>At least 1 uppercase character</li>
          <li>At least 1 number or special character</li></ul></p>
          <div className='text-center mt-4'>
            <Button
              type='submit'
              variant='link'
              className='btn-submit text-uppercase'
              onClick={this.props.handleClose}
            >
              Got it!
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default PasswordMessage;
